// src/constants/newTip.js
//
// Constantes du module New TIP. Doivent rester alignées avec
// config/new_tip.php côté Laravel.

export const CAMPAIGN_STATUSES = [
  { value: 'draft',  label: 'Brouillon', color: 'grey'    },
  { value: 'active', label: 'Active',    color: 'success' },
  { value: 'closed', label: 'Clôturée',  color: 'blue-grey' },
];

export const ASSIGNMENT_STATUSES = [
  { value: 'pending',   label: 'En attente', color: 'orange' },
  { value: 'visited',   label: 'Visitée',    color: 'info'   },
  { value: 'validated', label: 'Validée',    color: 'success' },
  { value: 'rejected',  label: 'Rejetée',    color: 'error'  },
];

export const VISIT_STATUSES = [
  { value: 'submitted', label: 'Soumise',  color: 'info'    },
  { value: 'validated', label: 'Validée',  color: 'success' },
  { value: 'rejected',  label: 'Rejetée',  color: 'error'   },
];

export const PHOTO_TYPES = {
  planogram_plv:  { label: 'Planogramme + PLV', min: 1, max: 1 },
  stock_products: { label: 'Stock produits',     min: 1, max: 6 },
  hats_collector: { label: 'Chapeau collector',  min: 1, max: 1 },
  other:          { label: 'Autre',               min: 0, max: 5 },
};

export const DEFAULT_VALUES = {
  stock_bonus_percentage: 20,
  hats_objective_qty: 150,
  gob_gain: 600,
  west_gain: 500,
  gub_gain: 300,
  hats_gain: 1500,
};

export const MAX_VISITS_PER_ASSIGNMENT = 2;

export function findStatus(list, value) {
  return list.find(s => s.value === value) || { value, label: value, color: 'grey' };
}
